import * as React from "react";
import "./Input.css";
import { useState } from 'react';

interface IProps {
    ClassName?: string;
    Type?: string;
    Name?: string;
    Value?: string | number;
    OnChange?: (evt) => void;
    OnBlur?: (evt) => void;
    Disabled?: boolean;
    Placeholder?: string;
    OnClick?: (evt: any) => void;
}

export const Input: React.SFC<IProps> = ({
    ClassName,
    Type,
    Name,
    Value,
    Disabled,
    Placeholder,
    OnClick,
    OnChange,
    OnBlur
}) => {

    const [hidden, setHidden] = useState(true);

    const HandleHidden = () => {
        setHidden(!hidden);
    }

    return (
        <div className="input-wrapper">
            <input
                type={Type === "password" ? hidden ? Type : "text" : Type}
                className={`input ${ClassName}`}
                name={Name}
                onChange={OnChange}
                onBlur={OnBlur}
                value={Value}
                disabled={Disabled}
                placeholder={Placeholder}
                onClick={OnClick}
            />
            {Type === "password" &&
                <div
                    onClick={HandleHidden}
                    className={`password-icon ${hidden ? "password-icon--reveal" : "password-icon--hide"}`} />
            }
        </div>
    );
};

Input.defaultProps = {
    ClassName: "",
    Type: "text",
    Name: "",
    Value: "",
    Disabled: false,
    Placeholder: "",
    OnClick: () => { },
    OnChange: () => { },
    OnBlur: () => { },
};


// WEBPACK FOOTER //
// ./src/controls/Form/Input.tsx